<template>
  <el-container class="content" style="display: block;">

	<el-container class="lables">

		<el-row  class="la-list">
			<el-col :span="10" class="first">
				<el-row>
					<div class="search">
						<input type="text" v-model="searchF" @change="loadData()"/>
					</div>
          <div class="add" @click="add(1)">+ 添加</div>

				</el-row>
				<el-row class="lable-o-l lable-o-ls" v-for="(item,index) in lableFirst" :key="index">
					<div class="lable-o" :class="{'choses':choseAF.indexOf(item.id)>-1&&item.id!=choses,'chosess':item.id==choses}"  @click="chose(item.id)">
          {{item.name}}
          </div>
          <i @click="delc(item.id)"  style="position: absolute;right: -20px;bottom: 5px;">删除</i>
				</el-row>
			</el-col>
			<el-col :span="4" class="centr"><img  src="../../assets/image/next.jpg"/></el-col>
			<el-col :span="10" class="two">
        <el-row>
        	 <el-col :span="20" style="text-align: center;">
        	   <el-upload
        	       class="upload-demo"
        	       ref="upload1"
        	       :action="action()"
        	       :on-preview="handlePreview"
        	       :before-upload="beforeUpload"
        	       :data="uploadData"
        	       :on-error = "error"
        	       :on-success="successResave"
        	       :on-remove="handleRemove"
        	       :file-list="fileList"
        	       :auto-upload="false">
        	       <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        	       <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
        	   </el-upload>

        	 </el-col>
        </el-row>
				<el-row>
					<div class="search">
						<input type="text"  v-model="searchT" @change="loadDataTwo()"/>
					</div>
					<div class="add" @click="add(2)">+ 添加</div>
          <span>{{count}}条</span>
				</el-row>
				<el-row class="lable-o-l">
					<div v-for="(item,index) in lableTwo" style="position: relative;">
					  <div class="lable-two"  :class="{'choses':choseAT.indexOf(item.id)>-1}" :key="index" @click="lableC(item.id,item.name)">
					  {{item.name}}</i>
					  </div>
					  <i @click="ceshi(item.id,index)"  style="position: absolute;right: -20px;bottom: 5px;">X</i>
					</div>
          <div class="page">
          	<el-pagination
          	  @size-change="loadDataTwo()"
          	  @current-change="loadDataTwo()"
          	  :current-page.sync="page"
          	  :page-size="500"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
				</el-row>
			</el-col>
		</el-row>

	</el-container>
	 <el-dialog
	  title="添加"
	  :visible.sync="centerDialogVisible"
	  width="30%"
	  center>
	  <input type="text" v-focus="picFocusStatus"  class="searchTsx" v-model="addT"/>


	  <span slot="footer" class="dialog-footer">
		<el-button @click="centerDialogVisible = false">取 消</el-button>
		<el-button type="primary" @click="doAdd()">确 定</el-button>
	  </span>
	</el-dialog>
	<el-dialog
	  title="提示"
	  :visible.sync="dialogVisible"
	  width="30%"

	  <span>指令与<{{acp}}>重复!是否继续添加?</span>
	  <span slot="footer" class="dialog-footer">
		<el-button @click="dialogVisible = false">取 消</el-button>
		<el-button type="primary" @click="doAdds()">确 定</el-button>
	  </span>
	</el-dialog>
  <el-dialog
    title="删除"
    :visible.sync="cdialogVisible"
    width="30%"
    center>
    <input type="text" v-focus="picFocusStatus"  class="searchTsx" v-model="delpass"/>


    <span slot="footer" class="dialog-footer">
  	<el-button @click="cdialogVisible = false">取 消</el-button>
  	<el-button type="primary" @click="dodelc()">确 定删除</el-button>
    </span>
  </el-dialog>
  </el-container>
</template>

<script>

  export default {
    data() {
      return {
       page:1,
       count:0,
       addTt:0,
        lableFirst:[],
		lableTwo:[],
		chosesT:0,
		choses:0,
		choseAF:[],
		choseAT:[],
		searchF:'',
		searchT:'',
		lable:[],
		lableEx:'',
    sx:1,
    ss:0,
		centerDialogVisible:false,
		addType:0,
		picFocusStatus:false,
		addT:'',
		dialogVisible: false,
		acp:'',
		addcf:0,
		token:window.localStorage.getItem('token'),
		userId:window.localStorage.getItem('id'),
		url:this.$store.getters.getUrl,
    uploadData:{},
    file:'',
    fileList:[],
    delId:0,
    cdialogVisible: false,
      };
    },
	directives: {
		focus: {
		  inserted: function(el, { value }) {
			if (value) {
			  el.focus();
			}
		  }
		}
    },
    created() {

      if(!window.localStorage.getItem('id')){
            this.$router.push({ path: '/' })
          }
       this.loadData();


    },

	methods:{
    delc(id){
      console.log(id)
      this.delId = id
      this.cdialogVisible = true
    },
    dodelc(){
      if(this.delpass == 'cikudel'){
        const axiosInstance = this.$axios.create({
        	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
        });
        axiosInstance({
        	method:'post',
        	params:{
        		id:this.delId,
        	},
        	url:'http://fencip.yoooooo.com/index.php/index/data/cikuDels'
        })
        .then(res=>{
        	if(res.data.code == 200){
            this.cdialogVisible = false
            this.loadData();

        	}else{
        		alert('删除失败')
        	}

        })
        .catch(err=>{

        });
      }

    },
    action(){
      return "http://8.131.71.50/upexcel"
    },
    submitUpload() {
      this.$refs.upload1.submit();
      let formData = new FormData();


    },
    actionAll(){
      return "http://8.131.71.50/upexcelall"
    },
    doUpload() {
      if(this.keys == 'self'){
        this.$refs.upload.submit();
        let formData = new FormData();
        this.keysDialogVisible = false
      }else{
        this.msg('验证词不正确','error')
        this.keysDialogVisible = false
      }



    },
    submitUploadAll() {
      this.keysDialogVisible = true


    },
    handleRemove(file, fileList) {

    },
    handlePreview(file) {

       console.log(file);
     },
     beforeUpload (file) {

        this.uploadData = {lid:this.choses,type:'ciku'};
        console.log(this.choses)

           let promise = new Promise((resolve) => {
               this.$nextTick(function () {
                   resolve(true);
               });
           });
           return promise;
    },
    //上传成功钩子
    successResave(response, file, fileList){
      console.log(response)
      if(response.code==200){
         alert('上传成功')
         this.loadDataTwo()
      }
    },
    //失败钩子
     error(response, file, fileList){
           console.log(response)
     },
    ceshi(id,index){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/cikuDel'
      })
      .then(res=>{
      	if(res.data.code == 200){

          this.lableTwo.splice(index,1)

      	}else{
      		alert('删除失败')
      	}

      })
      .catch(err=>{

      });
    },
		loadData(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchF

				},
				url:'http://fencip.yoooooo.com/index.php/index/data/cikuFirst'
			})
			.then(res=>{
				this.lableFirst = res.data;
        this.choses = this.lableFirst[0].id
        this.loadDataTwo()
			})
			.catch(err=>{

			});
		},
		loadDataTwo(){
      let c_id = this.choses;
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchT,
					p_id:c_id,
          p:this.page
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/cikunameTwo'
			})
			.then(res=>{
				this.lableTwo = res.data.data;
        this.count = res.data.count;
			})
			.catch(err=>{

			});
		},
		chose(id){
			this.choses = id;
			this.searchT = '';
			this.loadDataTwo();

		},
		lableC(id,name){
      this.chosesT = id;
      this.addT = name
      this.add(3);
		},

		add(type){
			this.addTt = type;
			this.centerDialogVisible = true;
			this.picFocusStatus = true

		},
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},
		nameChange(){
       let id = this.chosesT
			 const axiosInstance = this.$axios.create({
			 	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
			 	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			 });
			 axiosInstance({
			 	method:'post',
			 	params:{
          id:id,
			 		name:this.addT,

			 	},
			 	url:'http://fencip.yoooooo.com/index.php/index/data/cikuNameChange'
			 })
			 .then(res=>{
			 	if(res.data.code == 200){
			 		this.centerDialogVisible = false;
			 		this.addT = '';
			     this.loadDataTwo();
			 	}

			 })
			 .catch(err=>{

			 });
		},
    addCiku(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{

      		name:this.addT,

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/cikuAdd'
      })
      .then(res=>{
      	if(res.data.code == 200){
      		this.centerDialogVisible = false;
      		this.addT = '';
          this.loadData();
      	}

      })
      .catch(err=>{

      });
    },
    addCikuName(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		c_id:this.choses,
      		name:this.addT,

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/cikuNameAdd'
      })
      .then(res=>{
      	if(res.data.code == 200){
      		this.centerDialogVisible = false;
      		this.addT = '';
          this.loadDataTwo();
      	}

      })
      .catch(err=>{

      });
    },
		doAdd(){
			if(this.addTt == 1){
        this.addCiku()
      }
      if(this.addTt == 2){
        this.addCikuName()()
      }
      if(this.addTt == 3){
        this.nameChange()
      }

		}
	}


  }
</script>

<style>

	.content{
		background: #939AA0;
		width: 100%;
		height: 100%;
	}
	.centr{
		margin-top: 30%;
	}
	.centr img{
		width: 100px;
		height: 50px;
		margin-left: 35px;
	}

	.zhuyi{
		color: red;
    margin-left: 120px;
    font-size: 20px;
	}
	.butn{
		color: #F0F8FF;
		background: #FF9400;
		margin-right: 20px;
		border-radius: 5px;
		width: 50px;
	}
	.lables{
		margin-left: 5%;
		margin-right: 5%;
		background: #fff;
		padding-bottom: 35px;
	}
	.lables .la-list{
		margin-top: 50px;
		width: 100%;
		margin-left: 20%;
		margin-right: 20%;
	}
	.first{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.first .el-row{
		margin: 20px 10% 20px 10%;
	}
	.search input{
		width: 95%;
		height: 20px;
		margin-bottom: 10px;
		margin-left: 2%;
	}
	.add{
		text-align: center;
		width: 96%;
		background: #c6c6c6;
		height: 22px;
		line-height: 22px;
		margin-left: 2%;
	}

	.lable-o{
		width: 47%;
		text-align: center;
		background: #c6c6c6;
		height: 30px;
		line-height: 30px;
		margin-bottom: 10px;
	}
	.lable-two{

		text-align: center;
		background: #c6c6c6;

		line-height: 30px;
		margin-bottom: 10px;
	}
	.choses{
		background: #f8f1da;
	}
	.chosess{
		background: #ff9400;
	}
	.right{
		float: right;
	}
	.left{
		float: left;
	}
	.two{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.two .el-row{
		margin: 20px 10% 20px 10%;
	}
	.searchTsx{
		width: 30%;
		margin-left: 10%;
		height: 30px;
	}
  .s_or_x{
    width: 20%;
    height: 35px;
  }
	.lable-o-ls{
		border-bottom: 1px solid #c6c6c6;
	}
</style>



// WEBPACK FOOTER //
// src/components/main/Ciku.vue